import React from 'react';
import { cx } from './cx';

// Input / Select / Textarea share one recipe: §4 radius-sm, §3 control
// density, a carbon-900 recessed well (§2.1) inside a carbon-700 hairline,
// and the §11 focus ring.
//
// Placeholder text is carbon-400, not carbon-500. carbon-500 is a non-text
// token (§2.1) and lands at 2.45:1 on the well; carbon-400 gives 4.51.
const FIELD = [
  'w-full bg-carbon-900 border border-carbon-700',
  'rounded-radius-sm px-space-5 py-space-3',
  'text-body text-carbon-100 placeholder:text-carbon-400',
  'transition-[background-color,border-color,color] duration-fast ease-standard',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent',
  'disabled:text-carbon-500 disabled:cursor-not-allowed',
].join(' ');

export function Input({ className, type = 'text', ...rest }) {
  return <input type={type} className={cx(FIELD, className)} {...rest} />;
}

export function Select({ className, children, ...rest }) {
  return (
    <select className={cx(FIELD, 'cursor-pointer', className)} {...rest}>
      {children}
    </select>
  );
}

export function Textarea({ className, ...rest }) {
  return <textarea className={cx(FIELD, 'resize-y', className)} {...rest} />;
}
